import { MARBLE_STATES } from "@marble/core/modules/states";
import {
  EventAccess,
  EventStatus,
  EventType,
  EventZoomSessionType,
  Language,
} from "@prisma/client";

export const DEFAULT_WORKSHOP_DURATION_MINUTES = 60;

export const WORKSHOP_SESSIONS_TAGLINE =
  "Free live sessions from Marble clinicians for you and your families";

/** Shown on a professional-development workshop, not the parent line above. */
export const PROFESSIONAL_WORKSHOP_SESSIONS_TAGLINE =
  "Free live sessions from Marble clinicians for school staff";

export const WORKSHOP_DURATION_MINUTE_OPTIONS = [
  30, 45, 60, 75, 90, 120,
] as const;

export const EVENT_TYPE_LABELS: Record<EventType, string> = {
  [EventType.PARENT_WORKSHOP]: "Parent",
  [EventType.PROFESSIONAL_DEVELOPMENT_WORKSHOP]: "PD",
};

export const EVENT_ZOOM_SESSION_TYPE_LABELS: Record<
  EventZoomSessionType,
  string
> = {
  [EventZoomSessionType.WEBINAR]: "Webinar",
  [EventZoomSessionType.MEETING]: "Meeting",
};

export const EVENT_ACCESS_LABELS: Record<EventAccess, string> = {
  [EventAccess.PUBLIC]: "Public",
  [EventAccess.PRIVATE]: "Private",
};

/** Workshops are conducted in English or Spanish. Emails and invites follow this. */
export const WORKSHOP_LANGUAGES = [Language.ENGLISH, Language.SPANISH] as const;

export type WorkshopLanguage = (typeof WORKSHOP_LANGUAGES)[number];

export const EVENT_LANGUAGE_LABELS: Record<WorkshopLanguage, string> = {
  [Language.ENGLISH]: "English",
  [Language.SPANISH]: "Spanish",
};

export const EVENT_STATUS_LABELS: Record<EventStatus, string> = {
  [EventStatus.DRAFT]: "Draft",
  [EventStatus.ACTIVE]: "Active",
  [EventStatus.COMPLETED]: "Completed",
  [EventStatus.CANCELLED]: "Cancelled",
  [EventStatus.DELETED]: "Deleted",
};

export const EVENT_STATUS_BADGE_VARIANT: Record<
  EventStatus,
  "secondary" | "success" | "default" | "warning" | "error"
> = {
  [EventStatus.DRAFT]: "secondary",
  [EventStatus.ACTIVE]: "success",
  [EventStatus.COMPLETED]: "default",
  [EventStatus.CANCELLED]: "warning",
  [EventStatus.DELETED]: "error",
};

export const EVENT_CE_STATE_LABELS: Record<string, string> = Object.fromEntries(
  MARBLE_STATES.map((state) => [state, state]),
);

export const WORKSHOP_OWNER_MUST_BE_ADMIN_ERROR = "Owner must be an admin.";

export const HOST_EMAIL_IN_USE_ERROR = "A host with this email already exists.";

export const HOST_NOT_FOUND_ERROR = "Host not found.";

export const WORKSHOP_ACCESS_ZOOM_PAIRING_ERROR =
  "Private workshops use Zoom meetings; public workshops use webinars.";
